import React from "react";
import Post1 from "./../../assets/images/feed1.png";
import Post2 from "./../../assets/images/feed2.png";
import Post3 from "./../../assets/images/feed3.png";
import Post4 from "./../../assets/images/feed4.png";
import Insta from "./../../assets/images/insta.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./feed.css";
const Feed = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1376,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          adaptiveHeight: true,
          infinite: true,
          arrows: false,
          dots: false,
        //   centerMode: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          infinite: true,
          arrows: false,
          dots: false,
        //   centerMode: true,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1.05,
          slidesToScroll: 1,
          adaptiveHeight: true,
          infinite: true,
          arrows: false,
          dots: false,
        //   centerMode: true,
        },
      },
    ],
  };
  return (
    <div className="feed">
      <p className="feed_heading">Share Your Beauty</p>
      <p className="feed_description">
        Tag us on social media for a chance to be featured on our page and
        inspire others with your stunning looks!
      </p>
      <div className="post_container">
        <Slider {...settings}>
          <div>
            <div className="post">
              <img src={Post1} alt="" className="bg" />
              <div className="post_footer">
                <img src={Insta} alt="" />{" "}
                <p className="username">#Mixybeauty</p>
              </div>
            </div>
          </div>
          <div>
            <div className="post">
              <img src={Post2} alt="" className="bg" />
              <div className="post_footer">
                <img src={Insta} alt="" />{" "}
                <p className="username">#Mixybeauty</p>
              </div>
            </div>{" "}
          </div>
          <div>
            <div className="post">
              <img src={Post3} alt="" className="bg" />
              <div className="post_footer">
                <img src={Insta} alt="" />{" "}
                <p className="username">#Mixybeauty</p>
              </div>
            </div>{" "}
          </div>
          <div>
            <div className="post">
              <img src={Post4} alt="" className="bg" />
              <div className="post_footer">
                <img src={Insta} alt="" />{" "}
                <p className="username">#Mixybeauty</p>
              </div>
            </div>
          </div>
          <div>
            <div className="post">
              <img src={Post1} alt="" className="bg" />
              <div className="post_footer">
                <img src={Insta} alt="" />{" "}
                <p className="username">#Mixybeauty</p>
              </div>
            </div>
          </div>
          <div>
            <div className="post">
              <img src={Post2} alt="" className="bg" />
              <div className="post_footer">
                <img src={Insta} alt="" />{" "}
                <p className="username">#Mixybeauty</p>
              </div>
            </div>{" "}
          </div>
          <div>
            <div className="post">
              <img src={Post3} alt="" className="bg" />
              <div className="post_footer">
                <img src={Insta} alt="" />{" "}
                <p className="username">#Mixybeauty</p>
              </div>
            </div>{" "}
          </div>
          <div>
            <div className="post">
              <img src={Post4} alt="" className="bg" />
              <div className="post_footer">
                <img src={Insta} alt="" />{" "}
                <p className="username">#Mixybeauty</p>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default Feed;
